import cx from "classnames";
import styles from "./FigureCaption.module.css";

export const FigureCaption = ({ children, caption, credits, half }) => (
  <figure className={cx(styles.figure, { [styles.half]: half })}>
    {children}
    {(credits || caption) && (
      <figcaption className={styles.caption}>
        {caption}
        {credits && <div className={styles.credits}>{credits}</div>}
      </figcaption>
    )}
  </figure>
);
